import React, { useEffect, useState } from 'react';
import SITE from '../api';
import WorldMap from '../../components/WorldMap';
import useSEO from '../useSEO';

// Every country we have a registered/active customer in (derived live off
// customers.country_id, so a fresh signup from a new country lights up here
// with no manual step), plus any country an admin has hand-picked in
// Website Editor → World Map. Linked from the footer's "Other Links" column.
export default function WorldUsers() {
  const [countries, setCountries] = useState(null);

  useEffect(() => { SITE.get('/world-users').then(r => setCountries(r.data.countries || [])).catch(() => setCountries([])); }, []);

  useSEO({
    title: 'World Users',
    description: `Salvador Eyewear ships wholesale eyeglass frames and sunglasses to opticians and distributors in ${countries?.length || 'more than 100'} countries worldwide.`,
    keywords: 'Salvador Eyewear countries, wholesale eyewear export countries, global eyewear distributor',
    canonical: `${window.location.origin}/store/world-users`,
  });

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto', padding: '40px 24px 70px' }}>
      <h1 style={{ fontSize: 26, fontWeight: 700, color: '#191919', marginBottom: 6 }}>World Users</h1>
      {countries === null ? (
        <p style={{ color: '#999' }}>Loading…</p>
      ) : (
        <>
          <p style={{ fontSize: 14, color: '#777', marginBottom: 24 }}>
            Salvador Eyewear ships to {countries.length} countr{countries.length === 1 ? 'y' : 'ies'} worldwide.
          </p>
          <WorldMap highlightCodes={countries.map(c => c.code)} height={420} color="var(--sf-primary, #1a3c5e)" />
          {countries.length > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 28 }}>
              {countries.map(c => (
                <span key={c.code} style={{ background: '#f1f5f9', color: '#333', fontSize: 13, padding: '6px 14px', borderRadius: 20 }}>{c.name}</span>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
